import { motion } from 'framer-motion';
import { Pencil, Share2 } from 'lucide-react';

const ProfileActionButtons = ({ isOwnProfile, onEdit, onShare }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.05, duration: 0.35 }}
    className="mt-5 grid grid-cols-2 gap-3"
  >
    {isOwnProfile ? (
      <button
        type="button"
        onClick={onEdit}
        className="inline-flex items-center justify-center gap-2 rounded-2xl bg-surface-100 px-4 py-3 text-sm font-semibold text-surface-800 shadow-sm transition hover:bg-surface-200 active:scale-[0.98] dark:bg-[#1B2435] dark:text-white dark:hover:bg-[#243044]"
      >
        <Pencil size={15} strokeWidth={2} />
        Edit profile
      </button>
    ) : (
      <button
        type="button"
        onClick={onEdit}
        className="inline-flex items-center justify-center gap-2 rounded-2xl bg-surface-100 px-4 py-3 text-sm font-semibold text-surface-800 shadow-sm transition hover:bg-surface-200 active:scale-[0.98] dark:bg-[#1B2435] dark:text-white"
      >
        View profile
      </button>
    )}
    <button
      type="button"
      onClick={onShare}
      className="inline-flex items-center justify-center gap-2 rounded-2xl bg-surface-100 px-4 py-3 text-sm font-semibold text-surface-800 shadow-sm transition hover:bg-surface-200 active:scale-[0.98] dark:bg-[#1B2435] dark:text-white dark:hover:bg-[#243044]"
    >
      <Share2 size={15} strokeWidth={2} />
      Share
    </button>
  </motion.div>
);

export default ProfileActionButtons;
